import { Select } from 'antd';
import { ArrowDownIcon } from 'assets/icons/arrow-down';
import { SortedSelect } from 'components/ui/sorted-select';
import { EQueryKeys } from 'constants/query-keys';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { referenceDataApi } from 'services/apis';

interface ICurrencySelectorProps {
  defaultValue?: string;
  allowClear?: boolean;
  currencies?: string[];
  onChange?: (value: string) => void;
}

export const CurrencySelector = (props: ICurrencySelectorProps) => {
  const { t } = useTranslation();

  const { data: currencies, isLoading: isLoadingCurrencies } = useQuery(
    EQueryKeys.CURRENCIES,
    async () => {
      return referenceDataApi.getCurrencies();
    },
    {
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      enabled: isEmpty(props.currencies),
    }
  );

  return (
    <SortedSelect
      allowClear={props.allowClear}
      size="large"
      defaultValue={props.defaultValue}
      placeholder={t('submission.selectCurrency')}
      loading={isLoadingCurrencies}
      onChange={props.onChange}
      options={
        props.currencies
          ? props.currencies.map((currency) => ({
              label: currency,
              value: currency,
            }))
          : (currencies || []).map((currency) => ({
              label: `${currency.name} (${currency.code})`,
              value: currency.code,
            }))
      }
      labelRender={(option) => (
        <div className="flex items-center gap-2">
          <span className="text-gray-500">{t('general.currency')}: </span>
          <span>{option.value}</span>
        </div>
      )}
      suffixIcon={<ArrowDownIcon />}
    ></SortedSelect>
  );
};
